import { useQuery } from 'react-query';
import { minutes5inMS } from '../constants/times';
import { useSession } from '@sls-react/contexts/SessionContext';
import fetcher from '@sls-react/api/fetcher';
import { RailsSessionUser } from '@sls-react/typings/services/rails/session';
import { useCustomEvent } from '@sls-react/lib/events/customEvents';
import { getKnownCookie, setKnownCookie } from '@sls-react/hooks/cookies';

// Set a cookie when the user's purchase count is greater than 0.
// We use this to prevent Paypal from sending anonymous users offers, whom
// we know have purchased before.
function setPurchaseCountCookie(data: { user: RailsSessionUser }) {
  if (getKnownCookie('sls_user_haspc') !== '1') {
    if (data?.user?.properties?.purchase_count > 0) {
      setKnownCookie('sls_user_haspc', '1', {
        expires: 3000,
      });
    }
  }
}

export default function useV1Session(shouldFetch = true) {
  const { loggedIn } = useSession();

  const q = useQuery(
    'v1-session',
    () => fetcher<{ user: RailsSessionUser }>('/v1/session'),
    {
      enabled: shouldFetch && loggedIn,
      staleTime: minutes5inMS,
      onSuccess: setPurchaseCountCookie,
    },
  );

  useCustomEvent('sls_logout', q.remove);

  return q;
}
